module.exports = __webpack_public_path__ + "static/media/coming soon.2541b75b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coming soon.jpg
// module id = 373
// module chunks = 0